import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../services/wrapper-http-service';
import { API_URL } from '../../../../services';
import { AssignableCompartmentList } from '../../../../container-components';
import { AssignableCompartment } from './constants';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class AssignableCompartmentListService {
  constructor(private http: WrapperHttpService) {}

  getAssignableCompartmentList(hubIds: number[]): Observable<AssignableCompartmentList[]> {
    let params = new HttpParams();
    for (const i in hubIds) {
      if (i) {
        params = params.append('hubIds', hubIds[i].toString());
      }
    }
    const url = `${API_URL}${AssignableCompartment.Hubs}${AssignableCompartment.Compartments}${AssignableCompartment.Assignable}/`;
    return this.http.withLoading().get<AssignableCompartmentList[]>(url, { params });
  }
}
